"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomRubricSerializer = void 0;
var custom_rubric_model_1 = require("../../models/custom-rubric.model");
var CustomRubricSerializer = /** @class */ (function () {
    function CustomRubricSerializer() {
    }
    CustomRubricSerializer.prototype.serialize = function (customRubric) {
        return new custom_rubric_model_1.CustomRubric({
            id: customRubric.id,
            name: customRubric.name,
            curriculum: customRubric.curriculum,
            grade: customRubric.grade,
            type: customRubric.type,
            module: customRubric.module,
            rubric: {
                ratings: this.serializeRatings(customRubric.rubric.ratings),
                categories: this.serializeCategories(customRubric.rubric.categories),
            },
            status: customRubric.status,
            scoringType: customRubric.scoringType,
        });
    };
    CustomRubricSerializer.prototype.serializeRatings = function (ratings) {
        return ratings.map(function (rating) { return ({
            id: rating.id,
            description: rating.description,
            proficiency: rating.proficiency,
            maxScorePercentageValue: rating.maxScorePercentageValue,
        }); });
    };
    CustomRubricSerializer.prototype.serializeCategories = function (categories) {
        var _this = this;
        return categories.map(function (category) { return ({
            id: category.id,
            name: category.name,
            weight: category.weight,
            default: category.default,
            criteria: _this.serializeCriteria(category.criteria),
        }); });
    };
    CustomRubricSerializer.prototype.serializeCriteria = function (criteria) {
        return criteria.map(function (criterion) { return ({
            id: criterion.id,
            standards: criterion.standards,
            description: criterion.description,
            score: criterion.score,
        }); });
    };
    return CustomRubricSerializer;
}());
exports.CustomRubricSerializer = CustomRubricSerializer;
